// Component to show ui componenent where functionality is no ready yet

import { ReactNode, MouseEvent } from 'react'
import { toast } from 'react-toastify'

interface NotReadyProps {
  message?: string
  children?: ReactNode
  className?: string
}

export const NotReady = ({
  message = 'This feature is not ready yet',
  children,
  className = '',
}: NotReadyProps) => {
  const handleInteraction = (e: MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    toast(message, {
      position: 'bottom-center',
      autoClose: 1500,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    })
  }

  return (
    <div
      onClick={handleInteraction}
      onClickCapture={handleInteraction}
      className={className}
      style={{ pointerEvents: 'all', cursor: 'pointer' }}
    >
      {children || <div>NotReady</div>}
    </div>
  )
}
